import React, { Component } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ResourceImage } from '.';
import { getConfigurationDataKey } from '../utils';

interface AuthLayoutProps {
  image?: string | null;
  banner?: React.ReactNode;
  children: React.ReactNode;
}

export class AuthLayout extends Component<AuthLayoutProps> {
  render() {
    return (
      <Container fluid className='auth-layout-container'>
        <Row>
          {!this.props.image && (
            <Col className='overflow-hidden p-0 authlayout_custom_image d-md-block w-100 w-md-75 w-lg-50' />
          )}
          {this.props.image && (
            <Col className='overflow-hidden p-0 authlayout_custom_image w-100'>
              <ResourceImage contentKey='login.image' className='bg-image' />
            </Col>
          )}
        </Row>
        <Row className='login-box-container'>
          {this.props.banner && <div className='login-banner-overlay'>{this.props.banner}</div>}
          <Col className='login-box'>
            <div className='login-box-border'></div>
            <div className='login-box-inner' />
            <div className='login-logo-div'>
              <ResourceImage
                contentKey={getConfigurationDataKey('header.logo')}
                className='cmx__logo-toolbar__image pointer'
              />
            </div>
            <div className='login-content-div'>
              <div className='login-control-div'>
                <div className='w-lg-50 mx-auto'>{this.props.children}</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

interface AuthLayoutHeaderProps {
  title: string;
  children: React.ReactNode;
}

export class AuthLayoutHeader extends Component<AuthLayoutHeaderProps> {
  static displayName = 'AuthLayoutHeader';

  render() {
    return (
      <div className='text-center text-custom-50 pb-2'>
        <h3>{this.props.title}</h3>
        <h6 className='text-left'>{this.props.children}</h6>
      </div>
    );
  }
}
